import { Injectable } from '@angular/core';
import { Paginator, SortDirection } from '@app/classes';
import { ApplicantIndividualMessage } from '@app/models/recruiting/applicant-individual-message.model';
import { Applicant } from '@app/models/recruiting/applicant.model';
import { Table } from '@app/modules/table/classes/table.class';
import { DateSentColumn, FromColumn, StatusColumn, SubjectColumn } from './columns';

@Injectable()
export class EmailHistoryIndexTable extends Table {
    sortDirection = SortDirection.DESC;
    links = true;
    emitRowClickedWithLinksEnabled = true;
    protected sortProperty = 'createdAt';

    constructor(private applicant: Applicant) {
        super();
        this.boot();
    }

    getLink(applicantIndividualMessage: ApplicantIndividualMessage): (string | number)[] {
        return [
            '/recruiting',
            'applicants',
            applicantIndividualMessage.atsApplicantId,
            'emails',
            applicantIndividualMessage.id,
        ];
    }

    setColumns(): void {
        const emailDateSentColumn = new DateSentColumn();

        const columns = [new FromColumn(), new SubjectColumn(), new StatusColumn(), emailDateSentColumn];

        this.addColumns(...columns);

        this.sortColumn = emailDateSentColumn;
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            ApplicantIndividualMessage.where('atsApplicantId', this.applicant.id).with('sender')
        );
    }
}
